import { render, staticRenderFns } from "./wx-user-tagging.vue?vue&type=template&id=d510a786"
import script from "./wx-user-tagging.vue?vue&type=script&lang=js"
export * from "./wx-user-tagging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports